import { cn } from "@/lib/utils";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import CardHeaderContent from "./CardHeaderContent";
import type { ExpandableCardProps } from "@/types/expandable-dashboard";

export default function ExpandableDashboardCard({
  icon,
  title,
  subtitle,
  status,
  progress,
  isExpanded,
  onToggle,
  children,
  locked = false,
  note,
  fullWidth = false,
  compact = false,
  headerClassNames = "",
  onClick,
}: ExpandableCardProps) {
  const isDisabled = locked || status === "in-curand" || status === "blocat";
  const canExpand = !isDisabled && !!children;
  const hasClickAction = !canExpand && !!onClick && !isDisabled;

  const headerProps = {
    icon,
    title,
    subtitle,
    status,
    compact,
    progress,
    locked,
    note,
    canExpand,
    isExpanded,
    isDisabled,
  };

  return (
    <Collapsible
      open={canExpand && isExpanded}
      onOpenChange={canExpand ? onToggle : undefined}
      className={cn(
        "bg-white rounded-xl border border-ds-border-200 overflow-hidden transition-shadow",
        isExpanded && canExpand ? "shadow-lg" : "shadow-sm",
        fullWidth && "col-span-full"
      )}
    >
      {hasClickAction ? (
        <button
          type="button"
          onClick={onClick}
          className={cn(
            "w-full text-left p-4 cursor-pointer hover:bg-ds-surface-50",
            headerClassNames
          )}
        >
          <CardHeaderContent {...headerProps} />
        </button>
      ) : (
        <CollapsibleTrigger
          disabled={!canExpand}
          className={cn(
            "w-full text-left p-4",
            canExpand && "cursor-pointer hover:bg-ds-surface-50",
            isExpanded && canExpand && "bg-ds-surface-50",
            !canExpand && "cursor-default",
            headerClassNames
          )}
        >
          <CardHeaderContent {...headerProps} />
        </CollapsibleTrigger>
      )}

      <CollapsibleContent>
        <div className="border-t border-ds-border-200 p-4 sm:p-5">{children}</div>
      </CollapsibleContent>
    </Collapsible>
  );
}
